module.exports = __webpack_public_path__ + "static/img/app-bike.f01c3c95.png";